import React from 'react';
import { TextInput, CheckBox } from 'src/components/common/modules/form';
import { SelectBox } from 'src/components/common/modules/form/select-box';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { Typo } from 'src/components/common/ui';
import { checkValue } from 'src/components/functions';
import {getLocalizedMessage} from "src/components/common/helper";
import {useStores} from "src/utils/useStore";

const FormElement = ({
  controller: {
    module,
    uniquekey,
    question,
    prefilledText,
    value,
    options,
    isValid,
    questionMain,
    question1,
    question2,
    question3,
    question1PrefilledText,
    question2PrefilledText,
    question1Uniquekey,
    question2Uniquekey,
    question3Uniquekey,
    question1Value,
    question2Value,
    question3Value,
    question1IsValid,
    question2IsValid,
    question3IsValid,
    heading,
    subheading,
    smallDescription,
  },
  handleChange,
}: any) => {
  const { context: storeContext } = useStores();

  switch (module) {
    case 'entryFormText':
            return (
        <>
          <TextInput
            id={uniquekey}
            label={question}
            value={value}
            gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
            exClass={`input-box entryform-input`}
            invalid={isValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
            placeholder={prefilledText ? prefilledText : ' '}
            onChangeEvent={handleChange}
          ></TextInput>
          {smallDescription && (
            <span className="entry-form-small-text" dangerouslySetInnerHTML={{ __html: smallDescription }} />
          )}
        </>
      );
    case 'entryFormDropdown':
      return (
        <>
          <SelectBox
            id={uniquekey}
            label={question}
            value={value}
            options={options}
            gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
            initialOption={{ label: prefilledText ? prefilledText : 'Select', value: '' }}
            exClass={`input-box entryform-input ${isValid ? '' : 'invalid'} ${!checkValue(value) ? 'no-selected-value' : ''}`}
            invalid={isValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
            onChangeEvent={handleChange}
          ></SelectBox>
          {smallDescription && (
            <span className="entry-form-small-text" dangerouslySetInnerHTML={{ __html: smallDescription }} />
          )}
        </>
      );
    case 'entryFormCheckbox':
      return (
        <CheckBox
          id={uniquekey}
          label={question}
          value={value}
          gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
          exClass={`input-box entryform-input ${isValid ? '' : 'invalid'} checkbox-input`}
          errorMessage={isValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
          onChangeEvent={handleChange}
        ></CheckBox>
      );
    case 'entryFormText2QuestionsOn1Line':
      return (
        <>
          <UitkLayoutFlex space="six" wrap="wrap">
            {question1 && (
              <UitkLayoutFlexItem grow={1}>
                <div>
                  <TextInput
                    id={question1Uniquekey}
                    label={question1}
                    value={question1Value}
                    gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
                    exClass={`input-box entryform-input`}
                    invalid={question1IsValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
                    placeholder={question1PrefilledText ? question1PrefilledText : ' '}
                    onChangeEvent={handleChange}
                  ></TextInput>
                </div>
              </UitkLayoutFlexItem>
            )}
            {question2 && (
              <UitkLayoutFlexItem grow={1}>
                <div>
                  <TextInput
                    id={question2Uniquekey}
                    label={question2}
                    value={question2Value}
                    gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
                    exClass={`input-box entryform-input`}
                    invalid={question2IsValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
                    placeholder={question2PrefilledText ? question2PrefilledText : ' '}
                    onChangeEvent={handleChange}
                  ></TextInput>
                </div>
              </UitkLayoutFlexItem>
            )}
          </UitkLayoutFlex>
          {smallDescription && (
            <span className="entry-form-small-text" dangerouslySetInnerHTML={{ __html: smallDescription }} />
          )}
        </>
      );
    case 'entryFormMultipleCheckbox':
      return (
        <>
          {questionMain && <label>{questionMain}</label>}
          <UitkLayoutFlex className="entry-form-multi-checkbox">
            {question1 && (
              <UitkLayoutFlexItem grow={1}>
                <div>
                  <CheckBox
                    id={question1Uniquekey}
                    label={question1}
                    value={question1Value}
                    gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
                    exClass={`input-box entryform-input ${question1IsValid ? '' : 'invalid'} checkbox-input`}
                    errorMessage={question1IsValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
                    onChangeEvent={handleChange}
                  ></CheckBox>
                </div>
              </UitkLayoutFlexItem>
            )}
            {question2 && (
              <UitkLayoutFlexItem grow={1}>
                <div>
                  <CheckBox
                    id={question2Uniquekey}
                    label={question2}
                    value={question2Value}
                    gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
                    exClass={`input-box entryform-input ${question2IsValid ? '' : 'invalid'} checkbox-input`}
                    errorMessage={question2IsValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
                    onChangeEvent={handleChange}
                  ></CheckBox>
                </div>
              </UitkLayoutFlexItem>
            )}
            {question3 && (
              <UitkLayoutFlexItem grow={1}>
                <div>
                  <CheckBox
                    id={question3Uniquekey}
                    label={question3}
                    value={question3Value}
                    gaTracking={{ eventCategory: '', eventAction: '', eventLabel: '' }}
                    exClass={`input-box entryform-input ${question3IsValid ? '' : 'invalid'} checkbox-input`}
                    errorMessage={question3IsValid ? '' : getLocalizedMessage(storeContext?.locale?.toLocaleLowerCase(),"validation_error")}
                    onChangeEvent={handleChange}
                  ></CheckBox>
                </div>
              </UitkLayoutFlexItem>
            )}
          </UitkLayoutFlex>
        </>
      );
    case 'entryFormSubheading':
      return (
        <>
          {heading ? (
            <Typo.HTMLText tag="h2" exClass="entry-form-heading">
              {heading}
            </Typo.HTMLText>
          ) : null}
          {subheading ? (
            <Typo.HTMLText tag="p" exClass="entry-form-subheading">
              {subheading}
            </Typo.HTMLText>
          ) : null}
        </>
      );
    case 'entryFormCopyBlock':
      return (
        <>
          {question ? (
            <Typo.HTMLText tag="p" exClass="entry-form-subheading copy-block">
              {question}
            </Typo.HTMLText>
          ) : null}
        </>
      );
    default:
      return null;
  }
};

export default FormElement;
